import React, {Component} from "react";
import {connect} from "react-redux";

class BPHDBReportPolicyRemindPtdRow extends Component{
    constructor(props) {
        super(props);
    }
    componentDidMount() {
    }
    render() {
        const {index,item} = this.props;
        return(
            <tr>
                <td>{index + 1}</td>
                <td>{item?.alName}</td>
                <td>{item?.dobName}</td>
                <td>{item?.servicingCode}</td>
                <td>{item?.servicingName}</td>
                <td>{item?.bank}</td>
                <td>{item?.servicingIdentityNum}</td>
                <td>{item?.aoName}</td>
                <td>{item?.gBoToName}</td>
                <td>{item?.branchBsCode}</td>
                <td>{item?.branchName}</td>
                <td>{item?.policyNumber}</td>
                <td>{item?.poName}</td>
                <td>{item?.poMobileNumber}</td>
                <td></td>
                <td>{item?.poEmail}</td>
                <td>{item?.lfName}</td>
                <td>{item?.productStatusName}</td>
                <td>{item?.firstIssDate}</td>
                <td>{item?.ackDate}</td>
                <td>{item?.paymentMode}</td>
                <td>{item?.paidToDate}</td>
                <td className={'text-right'}>{item?.totalSa?.toLocaleString()}</td>
                <td className={'text-right'}>{item?.totalApe?.toLocaleString()}</td>
                <td className={'text-right'}>{item?.totalIp?.toLocaleString()}</td>
                <td className={'text-right'}>{item?.totalIp?.toLocaleString()}</td>
                <td className={'text-right'}>{item?.totalIp?.toLocaleString()}</td>
                <td>{item?.mainPlanName}</td>
                <td>{item?.saleChannel}</td>
                <td>{item?.reportDate}</td>
            </tr>
        )
    }
}
const mapStateToProps = (state) => {
    const authorities = state?.auth?.authorities;
    const isRoleHO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_HO');
    const isRoleFWDContest = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_CONTEST');
    const isRoleBO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BO');
    const isRoleTO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_TO');
    const username = state?.auth?.name;
    return { username,isRoleHO, isRoleFWDContest, isRoleBO, isRoleTO };
};

export default connect(mapStateToProps)(BPHDBReportPolicyRemindPtdRow)